import { render, staticRenderFns } from "./bbgl.vue?vue&type=template&id=1ea43ab9&scoped=true"
import script from "./bbgl.vue?vue&type=script&lang=js"
export * from "./bbgl.vue?vue&type=script&lang=js"
import style0 from "./bbgl.vue?vue&type=style&index=0&id=1ea43ab9&prod&lang=scss"
import style1 from "./bbgl.vue?vue&type=style&index=1&id=1ea43ab9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea43ab9",
  null
  
)

export default component.exports